import React, { useState } from "react";
import { inputs } from "../../utils/constants";
import { IoEyeOutline as Open } from "react-icons/io5";
import { IoEyeOffOutline as Closed } from "react-icons/io5";
import Select from "react-select"; // react-select'i import ediyoruz

const InputYeni = ({ page, value, onChange, className }) => {
  const [showPassword, setShowPassword] = useState(false);

  const filteredInputs = inputs.filter((input) =>
    input.visibleIn.includes(page)
  );

  // react-select için özel stil tanımları
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      maxWidth: "424px",
      height: "48px",
      borderRadius: "8px",
      borderWidth: "1px",
      borderColor: "rgba(203, 212, 225, 1)", // varsayılan border rengi
      boxShadow: "none",
      padding: "0 12px",
      display: "flex",
      justifyContent: "space-between",
      "&:hover": {
        borderColor: "rgba(203, 212, 225, 1)", // hover durumunda da aynı renk kalması için
      },
      "&:focus": {
        borderColor: "rgba(203, 212, 225, 1)", // focus durumunda da aynı renk kalması için
        outline: "none",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      color: "rgba(100, 116,139,1)",
      "&:hover": {
        backgroundColor: "rgba(244, 255, 220, 1)",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "rgba(100, 116,139,1)",
    }),
    menu: (provided) => ({
      ...provided,
      maxWidth: "424px",
      borderRadius: "8px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(100, 116, 139, 1)",
    }),
  };
  const customComponents = {
    IndicatorSeparator: () => null, // Varsa ayırıcı çizgiyi de kaldırır
  };
  return (
    <div className={`flex flex-col gap-4 w-full ${className || ""}`}>
      {filteredInputs.map((input, index) => (
        <div key={index} className=" flex flex-col gap-2">
          <label className="labelEdit">{input.label}</label>
          {input.type === "select" ? (
            <div>
              <Select
                options={input.options} // react-select için options
                name={input.name}
                defaultValue={
                  input.defaultValue
                    ? input.options.find(
                        (option) => option.value === input.defaultValue
                      ) // defaultValue'yu options içinde eşleştiriyoruz
                    : null
                }
                placeholder={input.placeholder || "Seçiniz"}
                styles={customStyles} // Özel stilleri uyguluyoruz
                components={customComponents}
                isSearchable={true} // Harfe göre filtreleme aktif
                classNamePrefix="react-select"
                required
              />
            </div>
          ) : (
            <div className="relative ">
              <img
                src={input.image}
                alt="Input Icon"
                className={`absolute left-[14px] top-[10px] size-[24px]`}
              />
              <input
                type={
                  input.type === "password" && showPassword
                    ? "text"
                    : input.type
                }
                placeholder={input.placeholder}
                autoComplete={input.name}
                name={input.name}
                className="custom-input pl-12 pr-4 w-full"
                value={value} // Dışarıdan gelen value
                onChange={onChange} // Dışarıdan gelen onChange
                required
              />
              {input.type === "password" && (
                <span
                  className="absolute right-3 top-3 text-grayy text-2xl cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <Open /> : <Closed />}
                </span>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default InputYeni;
